import React from "react";
import Modal from "./Modal";

const PrivacyPolicy = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Privacy Policy">
            <div className="max-w-3xl mx-auto p-6 text-gray-800 text-left">
                {/* <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1> */}
                <p className="mb-4">
                    At SoftEstimate, we respect your privacy. This Privacy Policy explains what data we collect, how we use it, and your rights.
                </p>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">1. No Personal Data Collection</h2>
                    <p>SoftEstimate does not collect, store, or process any personal data.</p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">2. Third-Party Services & Data Handling</h2>
                    <ul className="pl-3">
                        <li>✅ Authentication & Payments: Stripe, Google, and Microsoft handle all user authentication and subscription payments.
                        </li>
                        <li>✅ Hosting & Performance: Vercel hosts our platform, and their performance affects uptime.
                        </li>
                        <li>✅ Analytics & Logs: We may collect anonymous analytics (e.g., page visits) but do not track individual users.
                        </li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">3. Cookies & Tracking</h2>
                    <p>
                        SoftEstimate does not use cookies for tracking. However, third-party services (Stripe, Google, Microsoft) may use cookies and tracking technologies based on their policies.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">4. Compliance with US & EU Laws</h2>
                    <p>We follow GDPR, CCPA, and other privacy regulations. You have the right to:</p>
                    <ul className="pl-3">
                        <li>✅ Request information on any data shared with third parties.</li>
                        <li>✅ Opt out of third-party tracking (where applicable).</li>
                        <li>✅ Delete your third-party account data from Stripe, Google, or Microsoft.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">5. Security & Data Protection</h2>
                    <ul className="pl-3">
                        <li>✅ SoftEstimate does not store user data, reducing security risks.</li>
                        <li>✅ Payments and authentication are handled securely by Stripe, Google, and Microsoft.</li>
                        <li>✅ We recommend users follow best security practices when using third-party services.</li>
                    </ul>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">6. Updates & Changes</h2>
                    <p>
                        We may update this Privacy Policy from time to time. If you continue to use SoftEstimate, you agree to the latest version.
                    </p>
                </section>

                <section className="mb-6">
                    <h2 className="text-xl font-semibold mb-2">7. Contact for Privacy Concerns</h2>
                    <p>
                        For any privacy-related concerns, please email us at{" "}
                        <a href="mailto:admin@softestimate.com" className="text-blue-600 underline">
                            admin@softestimate.com
                        </a>.
                    </p>
                </section>
            </div>
        </Modal>
    );
};

export default PrivacyPolicy;
